import { t } from "i18next"
import { Validators } from "@callcenter/effector-helpers"
import { PASSWORD_REGEXP } from "@callcenter/shared-constants"

export const validatePassword = (password?: string) =>
  password
    ? Validators.pattern(PASSWORD_REGEXP, t("userProfile_userProfileSidePanel_password_validation"))(password)
    : ""

export const validateConfirmation = (
  _: unknown,
  __: string,
  { password, password_confirmation }: { password?: string; password_confirmation?: string }
) => (password === password_confirmation ? "" : t("userProfile_userProfileSidePanel_password_notMatch"))
